import Align from '../../../containers/probing/operations/Align';
import SafetyMove from './SafetyMove';
import ProbeFeatureTCPC from './ProbeFeatureTCPC';
import ProjectPointsOntoPlane from './ProjectPointsOntoPlane';
import IntersectLines from './IntersectLines';
import SetG5xOffset from './SetG5xOffset';
import * as probingConstants from '../../../constants/probing';

const probingOperations = {
  [probingConstants.ALIGN]: Align,
  [probingConstants.SAFETY_MOVE]: SafetyMove,
  [probingConstants.PROBE_FEATURE_TCPC]: ProbeFeatureTCPC,
  [probingConstants.PROJECT_POINTS_ONTO_PLANE]: ProjectPointsOntoPlane,
  [probingConstants.INTERSECT_LINES]: IntersectLines,
  [probingConstants.SET_G5X_OFFSET]: SetG5xOffset
};

export default probingOperations;
